const APP_ROUTES = {
    // explore: `/explore/${DEFAULT_FILTER_ID}`,
    explore: "/explore",
    mainExplore: "/explore",
};

export {
    APP_ROUTES,
};
